import { Pipe, PipeTransform } from '@angular/core';

/** removes leading https and trailing slash */
@Pipe({
  name: 'cleanUrl',
  standalone: false
})
export class CleanUrlPipe implements PipeTransform {
  public transform(value: string): string {
    if (!value) return value;
    return value.replace(/^https?:\/\//, '').replace(/\/$/, '');
  }
}
